import React from 'react';
import './Card.css'; // Ensure you have a Card.css file in the same directory

export const Card = ({ children }) => <div className="card">{children}</div>;
export const CardHeader = ({ children }) => <div className="card-header">{children}</div>;
export const CardContent = ({ children }) => <div className="card-content">{children}</div>;
export const CardTitle = ({ children }) => <div className="card-title">{children}</div>;

export default { Card, CardHeader, CardContent, CardTitle };
